// Pure helpers for interpreting Supabase Auth's signUp() response. No Supabase client, no
// React — kept separately so the exact discriminator logic is unit-testable without a live
// Auth call.

/**
 * Supabase deliberately returns a 200 — never an error — with an obfuscated/fake user object
 * when signUp() is called for an email that already belongs to a CONFIRMED account (both
 * "Confirm email" and "Confirm phone" enabled on the project). No new account is created and
 * no confirmation email is sent. `identities: []` is the documented discriminator for this
 * case: a genuinely new signup always has at least one identity.
 * https://supabase.com/docs/reference/javascript/auth-signup
 *
 * Only an actual empty array counts as evidence. `identities` missing, `null`, or any other
 * shape is NOT treated as "existing account" — a malformed/unexpected response must never be
 * silently misclassified as a successful existing-user detection, which would otherwise block
 * a genuine new registration from reaching the check-email step.
 */
export function isObfuscatedExistingUserResponse(identities: unknown): boolean {
  return Array.isArray(identities) && identities.length === 0
}
